import { render, staticRenderFns } from "./nav-bar.vue?vue&type=template&id=458a82fe&"
import script from "./nav-bar.vue?vue&type=script&lang=js&"
export * from "./nav-bar.vue?vue&type=script&lang=js&"
import style0 from "./nav-bar.vue?vue&type=style&index=0&id=458a82fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports